import { EntityModel } from '@/interfaces'
import {
  ALL_AGE_FILTERS_QUERY,
  CREATE_AGE_FILTER_MUTATION,
  DELETE_AGE_FILTER_MUTATION,
  FORCE_DELETE_AGE_FILTER_MUTATION,
  SINGLE_AGE_FILTER_QUERY,
  UPDATE_AGE_FILTER_MUTATION,
} from './graphql'

const travelPricingAgeFilterModel: EntityModel = {
  name: 'ageFilter',
  namePlural: 'ageFilters',
  uniqueName: 'travelPricingAgeFilter',
  uniqueNamePlural: 'travelPricingAgeFilters',
  path: 'travel/pricing/age_filter',
  baseUrl: '/travel/pricing/age_filters',
  translationPrefix: 'entities:travelPricingAgeFilter.',
  getDisplayName: (values: any) => {
    return 'Age Filter'
  },
  gql: {
    getAll: ALL_AGE_FILTERS_QUERY,
    getSingle: SINGLE_AGE_FILTER_QUERY,
    create: CREATE_AGE_FILTER_MUTATION,
    update: UPDATE_AGE_FILTER_MUTATION,
    delete: DELETE_AGE_FILTER_MUTATION,
    forceDelete: FORCE_DELETE_AGE_FILTER_MUTATION,
  },
  attributes: {
    minAge: {
      name: 'minAge',
      label: 'entities:travelPricingAgeFilter.attributes.minAge.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    maxAge: {
      name: 'maxAge',
      label: 'entities:travelPricingAgeFilter.attributes.maxAge.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
  },
}

export default travelPricingAgeFilterModel
